/**
 * @author Ezzo
 * Added on behalf of SAS 
 * I guess better to do this way ! update validation functionality on one Place is a blast ;)
 */
export const validatePhone = (phoneToTest) => {
    /**
     * Phone Number Combinations - 3 Cases to test
     * Country Key : +966 or 966
     * Full Phone Number example : +966504164474
     * Starts with 5 = 5-08657107 -> 8 digits left
     * Starts with 05 = 05-08657107 -> 8 digits left
     * Starts with 966 = 966-508657107 -> 9 digits left 
     */
    var key = "966";
    let phoneNumber = phoneToTest.trim();

    if (phoneNumber.startsWith("966") && phoneNumber.slice(3).length == 9) {

        return { valid: true, phoneNumber: key + phoneNumber.slice(3) }

    } else if (phoneNumber.startsWith("05") && phoneNumber.length == 10) {

        return { valid: true, phoneNumber: key + phoneNumber.slice(1) }

    } else if (phoneNumber.startsWith("5") && phoneNumber.length == 9) {
        return { valid: true, phoneNumber: key + phoneNumber }
    }
    else {

        return { valid: false, phoneNumber: null };

    }
}
